// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import QuestionCircleOutlinedSvg from "@ant-design/icons-svg/es/asn/QuestionCircleOutlined";
import AntdIcon from '../components/AntdIcon';

var QuestionCircleOutlined = function QuestionCircleOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: QuestionCircleOutlinedSvg
  }));
};

QuestionCircleOutlined.displayName = 'QuestionCircleOutlined';
export default React.forwardRef(QuestionCircleOutlined);